<template>
  <div>Electronic VEC / VEO</div>
</template>

<script>

  export default {
    name: "ElectronicVEC",
    components: {
    },
    data () {
      return {
      }
    },
    created() {     
    },
    mounted() {
    },
    methods: {
    },
    watch:
    {
    }

  }

</script>

<style scoped>

</style>
